<script>
  import TabNav from './tab-nav';

  export default {
    name: 'ZmTabs',

    components: {
      TabNav
    },

    props: {
      type: String,
      activeName: String,
      closable: Boolean,
      addable: Boolean,
      value: String,
      editable: Boolean,
      tabPosition: {
        type: String,
        default: 'top'
      },
      beforeLeave: Function,
      stretch: Boolean,
      ariaLabel: String
    },

    provide() {
      return {
        rootTabs: this
      };
    },

    data() {
      return {
        currentName: this.value || this.activeName,
        panes: []
      };
    },

    watch: {
      activeName(value) {
        this.setCurrentName(value);
      },
      value(value) {
        this.setCurrentName(value);
      },
      currentName(value) {
        if (this.$refs.nav) {
          this.$nextTick(() => {
            this.$refs.nav.$nextTick(_ => {
              this.$refs.nav.scrollToActiveTab();
            });
          });
        }
      }
    },

    methods: {
      calcPaneInstances() {
        if (this.$slots.default) {
          const paneSlots = this.$slots.default.filter(vnode => vnode.tag &&
            vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ZmTabPane');
          // update indeed
          const panes = paneSlots.map(({ componentInstance }) => componentInstance);
          if (!(panes.length === this.panes.length && panes.every((pane, index) => pane === this.panes[index]))) {
            this.panes = panes;
          }
        }
      },
      handleTabClick(tab, tabName, event) {
        if (tab.disabled) return;
        this.setCurrentName(tabName);
        this.$emit('tab-click', tab, event);
      },
      handleTabEnter(tab, tabName, event) {
        if (tab.disabled) return;
        this.setCurrentName(tabName);
        this.$emit('tab-enter', tab, event);
      },
      handleTabRemove(pane, ev) {
        if (pane.disabled) return;
        ev.stopPropagation();
        this.$emit('edit', pane.name, 'remove');
        this.$emit('tab-remove', pane.name);
      },
      setCurrentName(value) {
        const changeCurrentName = () => {
          this.currentName = value;
          this.$emit('input', value);
        };
        if (this.currentName !== value && this.beforeLeave) {
          const before = this.beforeLeave(value, this.currentName);
          if (before && before.then) {
            before.then(() => {
              changeCurrentName();

              this.$refs.nav && this.$refs.nav.removeFocus();
            }, () => {
              // ignore promise rejection in `before-leave` hook
            });
          } else if (before !== false) {
            changeCurrentName();
          }
        } else {
          changeCurrentName();
        }
      },
      setActiveName(value) {
        this.setCurrentName(value);
        this.$refs.nav && this.$refs.nav.$el.querySelector('[id=tab-' + value + ']') && this.$refs.nav.$el.querySelector('[id=tab-' + value + ']').focus();
      }
    },
    render(h) {
      let {
        type,
        handleTabClick,
        handleTabEnter,
        handleTabRemove,
        currentName,
        panes,
        tabPosition,
        stretch,
        ariaLabel
      } = this;

      const navData = {
        props: {
          currentName,
          onTabClick: handleTabClick,
          onTabEnter: handleTabEnter,
          onTabRemove: handleTabRemove,
          type,
          panes,
          stretch,
          ariaLabel
        },
        ref: 'nav'
      };
      const header = (
        <div class={['zm-tabs__header', `is-${tabPosition}`]}>
          <tab-nav {...navData}></tab-nav>
        </div>
      );
      const panels = (
        <div class="zm-tabs__content">
          {this.$slots.default}
        </div>
      );

      return (
        <div class={{
          'zm-tabs': true,
          'zm-tabs--card': type === 'card',
          'zm-tabs--capsule': type === 'capsule',
          'zm-tabs--pipeline': type === 'pipeline',
          [`zm-tabs--${tabPosition}`]: true,
          'zm-tabs--border-card': type === 'border-card'
        }}>
          {tabPosition !== 'bottom' ? [header, panels] : [panels, header]}
        </div>
      );
    },

    created() {
      if (!this.currentName) {
        this.setCurrentName('0');
      }
    },

    mounted() {
      this.calcPaneInstances();
    },

    updated() {
      this.calcPaneInstances();
    }
  };
</script>

<style lang="scss">
  @import "./style.scss";
</style>
